<template>
  <div style="background: #eff3f7;padding-top: 70px;" class="parent">
    <div
      style="width: 100%;height: 40px;background-color: red;position: fixed;top: 0;z-index: 999;text-align: center;color: white;font-size: 16px;line-height: 40px;"
    >
      警告：考试过程中禁止Esc/F11退出全屏，禁止Alt+Tab进行切屏，如有以上或类似违规操作将自动交卷！
    </div>

    <div class="page-header md-2018121001-xxw" style="z-index: 999;">
      <div class="clearfix container">
        <div class="logo-box pull-left">
          <a
            class="logo examlogo"
            href="javascript:;"
            style="left: 0;top:16px;
                                  font-weight: bold;font-size: 16px;color: #ffffff"
            >技能等级认定考试系统</a
          >
        </div>
        <ul class="nav-xxw pull-left">
          <!-- <li class=""><a class="shouye" href="/">首页</a></li> -->
          <li class="active"><a class="examZxks">在线考试</a></li>
        </ul>
        <!-- <div class="pull-right">
                    <a href="/" class="form-btn form-btn-blue from-save" id="out_login"
                        style="background-color: #4fc7ff;border-color: #4fc7ff;color: #ffffff;">退出</a>
                </div> -->
      </div>
    </div>

    <div class="page-body">
      <div class="ka numberCardModal">
        <div class="modal-header"></div>
        <div class="modal-body" id="modal-body">
          <div class="title">
            <div class="title_border"></div>
            <div class="title_content">答题卡</div>
          </div>

          <!-- 单选题 -->
          <div
            v-for="(item, index) in examSubjectlist"
            :key="index"
            class="card-content-list"
          >
            <div class="card-content">
              <div v-if="item.queType == '01'" class="card-content-title">
                单选题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>
              <div v-if="item.queType == '03'" class="card-content-title">
                判断题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>

              <div v-if="item.queType == '02'" class="card-content-title">
                多选题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>

              <div v-if="item.queType == '04'" class="card-content-title">
                填空题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>

              <div v-if="item.queType == '05'" class="card-content-title">
                证明题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>

              <div v-if="item.queType == '06'" class="card-content-title">
                分析题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>

              <div v-if="item.queType == '07'" class="card-content-title">
                解答题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>

              <div v-if="item.queType == '08'" class="card-content-title">
                实操题(共{{ item.SubjectCount }} 题，合计{{
                  item.queScoreSum
                }}分)
              </div>
              <div class="box-list">
                <div
                  v-for="(item1, index1) in item.examSubjectSonlist"
                  :key="index1"
                  class="box normal-box"
                  :style="
                    item1.userAnswer == null || item1.userAnswer == ''
                      ? ''
                      : 'background: #1A8CFE;'
                  "
                >
                  <a
                    class="iconBox que-btn"
                    :href="'#div' + item1.queType + (index1 + 1)"
                    :style="
                      item1.userAnswer == null || item1.userAnswer == ''
                        ? 'color: #616a89;'
                        : 'color: white;'
                    "
                    >{{ index1 + 1 }}<input class="queka" value="que1386"
                  /></a>
                </div>
              </div>
              <div class="split"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <span class="box icon-box s1"></span>
          <span class="icon-label">未答</span>
          <span class="box icon-box s2"></span>
          <span class="icon-label">已答</span>
        </div>
      </div>
      <div
        class="container paper-body-xxw"
        style="margin-left: 19%;margin-top: 23px;width: 70%;box-shadow: 0 1px 4px 0 rgba(58, 62, 81, 0.10);"
      >
        <div class="md-2018121002-xxw js-parent-box">
          <div
            v-for="(item, index) in examSubjectlist"
            :key="index"
            class="other-1221box js-single-box"
          >
            <div v-if="item.queType == '01'" class="other-1221-hd">
              单选题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '03'" class="other-1221-hd">
              判断题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '02'" class="other-1221-hd">
              多选题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '04'" class="other-1221-hd">
              填空题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '05'" class="other-1221-hd">
              证明题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '06'" class="other-1221-hd">
              分析题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '07'" class="other-1221-hd">
              解答题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div v-if="item.queType == '08'" class="other-1221-hd">
              实操题<span class="s1"
                >（合计 {{ item.SubjectCount }} 题，合计
                {{ item.queScoreSum }}分）</span
              >
            </div>
            <div class="other-1221-bd">
              <div
                v-for="(item1, index1) in item.examSubjectSonlist"
                :key="index1"
                class=" padding-100 js-single-select test-paper-list"
                :id="'div' + item1.queType + (index1 + 2)"
              >
                <div class="hd">
                  <div class="tit" data-questionsort="">
                    <i class="xxw107-icon"></i>
                    <div style="width: 35px;float:left;">{{ index1 + 1 }}.</div>
                    <div
                      v-html="item1.queQuestion"
                      style="width: 90%;display: inline-block"
                    >
                      <!-- <p>穿管敷设的铝芯绝缘导线的线芯最小截面应为（&nbsp; ）m㎡。</p> -->
                    </div>

                    <div
                      v-if="
                        item.queType != '01' &&
                          item.queType != '02' &&
                          item.queType != '03' &&
                          item.queType != '04' &&
                          item1.isAtt == 1
                      "
                      data-queid="6758"
                      class="layui-btn layui-btn-xs queAtt"
                      style="margin-left: 35px;margin-top: 0px"
                      @click="DownloadTheAttachment(item1)"
                    >
                      附件下载
                    </div>

                    <el-collapse
                      accordion
                      style="margin-top: 20px;margin-left: 35px;"
                      v-if="
                        item.queType != '01' &&
                          item.queType != '02' &&
                          item.queType != '03' &&
                          item.queType != '04'
                      "
                    >
                      <el-collapse-item>
                        <template slot="title">
                          请点击箭头处展开后作答<i
                            class="header-icon el-icon-info"
                          ></i>
                        </template>
                        <quill-editor
                          ref="text"
                          v-model="item1.userAnswer"
                          class="myQuillEditor"
                          style="margin-top: 10px;"
                          :options="editorOption"
                        />

                        <el-upload
                          class="upload-demo"
                          drag
                          style="margin-top: 20px;"
                          :action="action"
                          :on-success="
                            (res, file) =>
                              successFile(item1, index, index1, res, file)
                          "
                          :on-exceed="exceed"
                          :on-error="error"
                          :on-remove="
                            (file, fileList) =>
                              deleteFile(item1, index, index1, file, fileList)
                          "
                          :limit="1"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                          </div>
                          <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                        </el-upload>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
                <!-- 单选题 -->
                <el-radio-group
                  v-if="item.queType == '01'"
                  class="bd"
                  v-model="item1.userAnswer"
                  @change="multipleChoice(item1, index, index1)"
                >
                  <div
                    v-for="(item2, index2) in item1.queOptions"
                    :key="index2"
                    class="form-checkbox form-checkbox-info item-listx"
                  >
                    <label>
                      <el-radio :label="item2.serialNum">
                        <div style="display: flex;">
                          {{ item2.serialNum }}.
                          <div v-html="item2.optionContent"></div>
                        </div>
                      </el-radio>
                    </label>
                  </div>
                </el-radio-group>
                <!-- 判断题 -->
                <el-radio-group
                  @change="judgeChoiceChange(item1, index, index1)"
                  v-if="item.queType == '03'"
                  class="bd"
                  v-model="item1.userAnswer"
                >
                  <div class="form-checkbox form-checkbox-info item-listx">
                    <label>
                      <el-radio label="对">
                        <div style="display: flex;">对</div>
                      </el-radio>
                    </label>
                  </div>
                  <div class="form-checkbox form-checkbox-info item-listx">
                    <label>
                      <el-radio label="错">
                        <div style="display: flex;">错</div>
                      </el-radio>
                    </label>
                  </div>
                </el-radio-group>
                <!-- 多选题 -->
                <el-checkbox-group
                  @change="
                    val => multipleChoiceChange(item1, index, index1, val)
                  "
                  v-if="item.queType == '02'"
                  class="bd"
                  v-model="item1.userAnswerList"
                >
                  <div
                    v-for="(item2, index2) in item1.queOptions"
                    :key="index2"
                    class="form-checkbox form-checkbox-info item-listx"
                  >
                    <label>
                      <el-checkbox :label="item2.serialNum">
                        <div style="display: flex;">
                          {{ item2.serialNum }}.
                          <div v-html="item2.optionContent"></div>
                        </div>
                      </el-checkbox>
                    </label>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-wrapper">
        <div class="nav250 nav-status nav-operation">
          <ul class="menu-items">
            <li
              class="menu-item menu-item-time"
              style="border-bottom: 1px solid #eee;"
            >
              <div class="item-label">剩余时间</div>
              <div class="item-data" id="timeDown">{{ currentTime }}</div>
            </li>
            <li
              class="menu-item menu-item-process"
              style="border-bottom: 1px solid #eee;"
            >
              <div class="item-label">当前进度</div>
              <div class="item-data" id="jindu">
                <span id="commitCount">{{ currentProgress }}</span
                >/<span id="totalCount">{{ subjectSumCount }}</span>
              </div>
              <div class="item-process">
                <div class="item-process-bar" id="commitProcess"></div>
              </div>
            </li>
            <li
              class="menu-item menu-item-process"
              style="border-bottom: 1px solid #eee;"
            >
              <div class="item-label">考生姓名</div>
              <div class="item-data" id="userName">
                {{ this.$storage.get("declareUser").userName }}
              </div>
            </li>
          </ul>
        </div>
        <button
          href="###"
          @click="manualOperationHandInAnExaminationPaper"
          class="form-btn1 form-btn-blue from-save"
          style="width: 100%;"
        >
          交卷
        </button>
      </div>
    </div>
    <el-dialog title="附件下载" :visible.sync="dialogTableVisible" width="30%">
      <el-table :data="thatMaterialList">
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="附件名称"
          width="250"
          prop="attName"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>

        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              class="layui-btn layui-btn-xs"
              @click="download(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="40%">
      <div
        class="layui-layer layui-layer-page"
        id="layui-layer2"
        type="page"
        times="2"
        showtime="0"
        contype="string"
        style="z-index: 19891016; width:auto; top: 169.5px; left: 237.5px;"
      >
        <div id="LAY_layuipro" class="layui-layer-content">
          <div
            style="padding: 50px; line-height: 22px; background-color: #393D49; color: #fff; font-weight: 300;"
          >
            <p
              style="text-align: center;font-size: 21px;font-weight: 600; margin-bottom: 22px;"
            >
              职业技能等级认定
            </p>
            <p></p>
            <p style="text-align: center;margin-bottom: 32px;">
              {{ testName }}
            </p>
            <p style="margin-bottom: 15px;">注 意 事 项：</p>
            <p style="margin-bottom: 15px;">
              1、考试期间不可进行切屏、退出全屏操作，否则视作违规操作，自动进行交卷。
            </p>
            <p style="margin-bottom: 15px;">
              2、本试卷依据《{{ workTypeName }}》国家职业标准命制。
            </p>
            <p style="margin-bottom: 15px;">
              3、请仔细阅读答题要求，在规定位置填写答案。
            </p>

            <p style="margin-bottom: 15px;">
              4、考试时间：{{ testSetTime }}分钟。
            </p>
          </div>
        </div>
        <span class="layui-layer-setwin"></span>
        <div
          @click="BeginExam()"
          class="layui-layer-btn layui-layer-btn-c"
          style="text-align: center; height: 50px;line-height: 50px;"
        >
          <a
            class="layui-layer-btn0"
            style="    padding: 5px;
                    border-radius: 5px;"
            >开始考试</a
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var vm = null;
function _bindEventHandler(event) {
  // console.log("aaaaaaaa============"+event.keyCode)  // 键盘码
  //event.keyCode == 9 || event.keyCode == 18 || event.keyCode == 123
  if (event.keyCode) {
    //alert('qiepingle!!!!');
    //alt + tab   + esc 监控 发现直接强制交卷
    vm.compelHandInAnExaminationPaper();
  }
}

function _resizeEventHandler(event) {
  if (!vm.checkFull()) {
    //强制交卷
    vm.compelHandInAnExaminationPaper();
  }
  // vm.isFullscreen = true;
}
export default {
  name: "app",
  compoents: {},
  data() {
    return {
      testName: "",
      workTypeName: "",
      testSetTime: 0, //考试规定用时
      isFullscreen: false, // false非全屏状态、true全屏状态
      dialogVisible: true,
      subjectSumCount: 0,
      longTime: 0,
      action: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: [] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video"] // 链接、图片、视频
          ] //工具菜单栏配置
        },
        placeholder: "请在这里添加产品描述", //提示
        readyOnly: false, //是否只读
        theme: "snow", //主题 snow/bubble
        syntax: true //语法检测
      },
      thatMaterialList: [],
      dialogTableVisible: false,
      radio: "",
      currentTime: "",
      examId: 0,
      examSubjectlist: [],
      endTime: "",
      beginTime: "",
      timer: "",
      timer1: "",
      timer2: "",
      mapList: new Map(),
      currentProgress: 0,
      flag: true,
      screenfullFlag: true,
      testNormalDisableSwitch: true
    };
  },
  async created() {
    //考试界面添加水印
    this.$watermark({ watermark_txt: "技能等级认定" });

    //判断 如果是谷歌浏览器 世界退出考试
    // var userAgent = navigator.userAgent;
    //  var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1;
    // if(!isChrome){
    //     alert('不是谷歌浏览器！！！！！！！');
    // }else{
    //     alert('是谷歌浏览器！！！！！！！！');
    // }
    vm = this;
    let that = this;
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timer1) {
      clearInterval(this.timer1);
    }
    if (this.timer2) {
      clearInterval(this.timer2);
    }

    let el = document.documentElement;
    let rfs =
      el.requestFullScreen ||
      el.webkitRequestFullScreen ||
      el.mozRequestFullScreen ||
      el.msRequestFullscreen;
    if (rfs) {
      rfs.call(el);
    } else if (typeof window.ActiveXObject !== "undefined") {
      let wscript = new ActiveXObject("WScript.Shell");
      if (wscript != null) {
        wscript.SendKeys("{F11}");
      }
    }

    await this.getSysTime();
    this.action = this.serverUrl + "/deUp/uploadPracticeImage";
    this.testId = this.$route.query.testId;
    this.laodExamSubject(this.testId, this.$route.query.paperId);
  },
  mounted() {
    //循环富文本 内容进行保存
    let _this = this;

    //定时保存考试内容
    this.timer1 = setInterval(() => {
      _this.saveExamSchedule(_this);

      _this.updateExamState(1);
    }, 15000);

    //十秒 查询一次 看什么时候  考试被禁  直接结束开始
    /*  this.timer2 = setInterval(() => {


                //违规操作导致的考试状态变更 不进此方法
                if (this.testNormalDisableSwitch) {

                    let parames = new URLSearchParams();
                    parames.append('testId', this.$route.query.testId);
                    parames.append('examId', this.examId);
                    parames.append('userId', this.$storage.get("declareUser").id);
                    this.$axios.post(this.serverUrl + '/ex/selectUserTestState', parames).then(resp => {

                        if (resp.data.data[0].testState == 2) {
                            //考试结束
                            this.$message({
                                showClose: false,
                                duration: 3000,
                                message: '考试被管理员禁用，考试即将关闭！',
                                type: 'warning',
                                offset: 300
                            });

                            _this.updateExamState(2); //考试结束

                            //页面跳转
                            setTimeout(function () {

                                _this.$router.push({ path: '/examPrepositionPage' });

                            }, 3000);

                        }

                    }).catch(err => {

                    })

                }

            }, 10000) */

    //监听退出全屏
    //window.addEventListener('resize', _resizeEventHandler, true)

    // //监听键盘按键事件
    window.addEventListener("keyup", _bindEventHandler, true);

    window.addEventListener("resize", _resizeEventHandler, true);

    //监听退出全屏
    /* let that = this;
            window.onresize = function(){
                if(!that.checkFull()){
                要执行的动作
                that.compelHandInAnExaminationPaper();
                }
            } */

    //监控 当前页面失去焦点 直接结束考试！！
    //window.addEventListener('focusout', _onblurEventHandler, true);
    //window.onblur = function () {
    //_this.compelHandInAnExaminationPaper();
    //}

    //禁止鼠标右键！
    document.oncontextmenu = function(e) {
      return false;
    };

    //阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
    history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", function() {
      history.pushState(null, null, window.location.href);
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.timer1) {
      clearInterval(this.timer1);
    }
    /*  if (this.timer2) {
                clearInterval(this.timer2);
            } */

    window.removeEventListener("keyup", _bindEventHandler, true);
    window.removeEventListener("resize", _resizeEventHandler, true);

    // window.removeEventListener('focusout', _onblurEventHandler,true);

    window.onblur = null;
  },
  watch: {},
  methods: {
    checkFull() {
      var isFull =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      if (isFull === undefined) isFull = false;
      return isFull;
    },

    BeginExam() {
      this.dialogVisible = false;
    },
    //强制交卷
    compelHandInAnExaminationPaper() {
      const loading1 = this.$loading({
        lock: true,
        text: "监控到违规操作，考试即将结束!",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      let _that = this;
      setTimeout(function() {
        loading1.close();

        _that.handInAnExaminationPaper();
      }, 1000);
    },
    handInAnExaminationPaper() {
      this.testNormalDisableSwitch = false;

      const loading = this.$loading({
        lock: true,
        text: "交卷中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      this.saveExamSchedule(this); //保存学习进度

      let parames = new URLSearchParams();
      parames.append("testId", this.$route.query.testId);
      parames.append("userId", this.$storage.get("declareUser").id);
      let beginLongTime = new Date(this.beginTime).getTime();
      this.getSysTime();
      let currentLongTime = this.longTime - beginLongTime;
      parames.append("testUserDate", currentLongTime);
      parames.append("testState", 2);
      this.$axios
        .post(this.serverUrl + "/ex/updateUserExamOnlyUpdateUserState", parames)
        .then(resp => {
          let _that = this;
          setTimeout(function() {
            loading.close();
            _that.$message({
              type: "success",
              message: "交卷完毕!",
              offset: 300
            });
            _that.$router.push({ path: "/examPrepositionPage" });

            _that.testNormalDisableSwitch = true;
          }, 3000);
        })
        .catch(err => {});
    },
    //手动交卷
    manualOperationHandInAnExaminationPaper(state) {
      let beginLongTime = new Date(this.beginTime).getTime();
      this.getSysTime();
      let currentLongTime1 = this.longTime - beginLongTime;

      let _that = this;

      if (currentLongTime1 > 1800000) {
        if (state === 2) {
          //倒计时结束交卷
          this.handInAnExaminationPaper();
        } else {
          //手动交卷
          this.$confirm("您确定要交卷么, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info"
          })
            .then(() => {
              _that.handInAnExaminationPaper();
            })
            .catch(() => {});
        }
      } else {
        this.$message({
          showClose: true,
          message: "考试开始前30分钟，不可交卷！",
          type: "warning",
          offset: 300
        });
      }
    },
    //修改考试状态
    updateExamState(state) {
      let parames = new URLSearchParams();
      parames.append("testId", this.$route.query.testId);
      let beginLongTime = new Date(this.beginTime).getTime();
      this.getSysTime();
      let currentLongTime = this.longTime - beginLongTime;
      parames.append("testUserDate", currentLongTime);
      parames.append("testState", state);
      this.$axios
        .post(this.serverUrl + "/ex/updateUserExamOnlyUpdateUserState", parames)
        .then(resp => {})
        .catch(err => {});
    },
    //保存考试进度
    saveExamSchedule(_this) {
      //每次保存时 都将用户答案不为空的 保存进 mapList
      _this.examSubjectlist.forEach(function(element, index) {
        element.examSubjectSonlist.forEach(function(element1, idnex1) {
          if (element1.userAnswer != null && element1.userAnswer != "") {
            if (element.queType != "01" || element.queType != "03") {
              //单选判断
              let userScore = 0;
              let userAnsState = 2; //1正确 2错误

              if (element1.userAnswer === element1.queAnswer) {
                userScore = element1.queScore;
                userAnsState = 1;
              }

              // 将本题新定义对象 放入
              let saveTheTopic = {
                queId: element1.queId,
                userAnswer: element1.userAnswer,
                userScore: userScore,
                testId: _this.testId,
                userAnsState: userAnsState,
                userId: _this.$storage.get("declareUser").id
              };

              _this.mapList.set(element1.queId, saveTheTopic);
            }

            if (element1.queType == "02") {
              //多选题
              let userScore = 0;
              let userAnsState = 2; //1正确 2错误

              let userAnswerArray = element1.userAnswer.split(",");

              let queAnswerArray = element1.queAnswer.split(",");

              if (userAnswerArray.length === queAnswerArray.length) {
                userAnswerArray = userAnswerArray.sort();
                queAnswerArray = queAnswerArray.sort();

                if (
                  JSON.stringify(userAnswerArray) ==
                  JSON.stringify(queAnswerArray)
                ) {
                  userAnsState = 1;
                  userScore = element1.queScore;
                }
              }

              // 将本题新定义对象 放入
              let saveTheTopic = {
                queId: element1.queId,
                userAnswer: element1.userAnswer,
                userScore: userScore,
                testId: _this.testId,
                userAnsState: userAnsState,
                userId: _this.$storage.get("declareUser").id
              };

              _this.mapList.set(element1.queId, saveTheTopic);
            }

            if (
              element.queType != "01" &&
              element.queType != "02" &&
              element.queType != "03" &&
              element.queType != "04"
            ) {
              let saveTheTopic = {
                queId: element1.queId,
                userAnswer: element1.userAnswer,
                userScore: null,
                testId: _this.testId,
                userAnsState: null,
                userId: _this.$storage.get("declareUser").id
              };
              _this.mapList.set(element1.queId, saveTheTopic);
            }
          }
        });
      });

      let ArrayList = [];
      this.mapList.forEach(function(element, index) {
        ArrayList.push(element);
      });

      let userQueJson = JSON.stringify(ArrayList);

      let parames = new URLSearchParams();
      parames.append("userQueJson", userQueJson);

      this.$axios
        .post(this.serverUrl + "/ex/updateUserExam", parames)
        .then(resp => {
          if (resp.data.code == 1) {
            console.log("成功了！！！");
          }
        })
        .catch(err => {});
    },
    //判断选中
    judgeChoiceChange(item, index, index1) {
      let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1]
        .userAnswer;

      if (this.examSubjectlist[index].examSubjectSonlist[index1].state != 2) {
        this.currentProgress += 1;
      }

      this.examSubjectlist[index].examSubjectSonlist[index1].state = 2;

      /* let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1].userAnswer;
                let userScore = 0;
                let userAnsState = 2; //1正确 2错误

                if (userAnswer === item.queAnswer) {
                    userScore = item.queScore;

                    userAnsState = 1;

                }

                // 将本题新定义对象 放入
                let saveTheTopic = {
                    queId: item.queId,
                    userAnswer: userAnswer,
                    userScore: userScore,
                    testId: this.$route.query.testId,
                    userAnsState: userAnsState,
                    userId: "55",
                }

                this.mapList.set(item.queId,saveTheTopic); */
    },
    //多选选中
    multipleChoiceChange(item, index, index1, val) {
      let userAnswer = "";
      val.forEach(function(element, index3) {
        if (val.length === 1 || index3 === val.length - 1) {
          userAnswer += element;
        } else {
          userAnswer += element + ",";
        }
      });

      console.log(userAnswer);

      if (userAnswer === "") {
        this.currentProgress -= 1;

        this.examSubjectlist[index].examSubjectSonlist[index1].state = 1;
      } else {
        if (this.examSubjectlist[index].examSubjectSonlist[index1].state != 2) {
          this.currentProgress += 1;
        }

        this.examSubjectlist[index].examSubjectSonlist[index1].state = 2;
      }
      this.examSubjectlist[index].examSubjectSonlist[
        index1
      ].userAnswer = userAnswer;
    },
    // 单选选中
    multipleChoice(item, index, index1) {
      let userAnswer = this.examSubjectlist[index].examSubjectSonlist[index1]
        .userAnswer;

      console.log(this.examSubjectlist[index].examSubjectSonlist[index1].state);

      if (this.examSubjectlist[index].examSubjectSonlist[index1].state != 2) {
        this.currentProgress += 1;
      }

      this.examSubjectlist[index].examSubjectSonlist[index1].state = 2;
    },
    //距离考试结束
    showtime(beginTime, serverTime) {
      var lefttime = beginTime - serverTime; //距离结束时间的毫秒数
      var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)); //计算天数
      var lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24); //计算小时数
      var leftm = Math.floor((lefttime / (1000 * 60)) % 60); //计算分钟数
      var lefts = Math.floor((lefttime / 1000) % 60); //计算秒数

      if (lefttime <= 1000) {
        return "0:0:0"; //返回倒计时的字符串
      } else {
        return lefth + ":" + leftm + ":" + lefts; //返回倒计时的字符串
      }
    },
    //获取服务器时间
    getSysTime() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(this.serverUrl + "/serverTime/getServerTime")
          .then(resp => {
            this.longTime = resp.data.serverTime;
            resolve();
          })
          .catch(err => {});
      });
    },
    //文件上传失败
    error() {
      this.$message.error("文件上传失败！");
    },
    //文件超出限制 进的函数
    exceed(files, fileList) {
      this.$message({
        message: "请先删除当前文件，再上传！",
        type: "warning"
      });
    },
    //文件成功上传后走的方法
    successFile(item, index, index1, res, file) {
      //文件上传成功后  将数据再次插入到服务器
      let parames = new URLSearchParams();
      parames.append("userId", this.$storage.get("declareUser").id);
      parames.append("userName", this.$storage.get("declareUser").userName);
      parames.append("examId", this.examId);
      parames.append("testId", this.$route.query.testId);
      parames.append("paperId", this.$route.query.paperId);
      parames.append("queId", item.queId);
      parames.append("filePathOld", "");
      parames.append("filePath", res.src);
      parames.append(
        "fileName",
        file.name.substring(0, file.name.lastIndexOf("."))
      );

      this.$axios
        .post(this.serverUrl + "/ex/delUserTestFile", parames)
        .then(resp => {
          this.$message({
            showClose: true,
            message: "恭喜你，文件上传成功！",
            type: "success"
          });
        })
        .catch(err => {});

      //文件上传成功后将文件路径存入 examSubjectlist
      this.examSubjectlist[index].examSubjectSonlist[index1].filePathOld =
        res.src;
    },
    //删除文件
    deleteFile(item, index, index1, file, fileList) {
      //文件上传成功后  将数据再次插入到服务器
      let parames = new URLSearchParams();
      parames.append("userId", this.$storage.get("declareUser").id);
      parames.append("userName", this.$storage.get("declareUser").userName);
      parames.append("examId", this.examId);
      parames.append("testId", this.$route.query.testId);
      parames.append("paperId", this.$route.query.paperId);
      parames.append("queId", item.queId);
      parames.append(
        "filePathOld",
        this.examSubjectlist[index].examSubjectSonlist[index1].filePathOld
      );
      parames.append(
        "fileName",
        file.name.substring(0, file.name.lastIndexOf("."))
      );

      this.$axios
        .post(this.serverUrl + "/ex/delUserTestFile", parames)
        .then(resp => {
          this.$message({
            showClose: true,
            message: "文件删除成功！可以重新上传了！",
            type: "success"
          });
        })
        .catch(err => {});
    },
    //附件下载
    download(row) {
      window.open(this.serverUrl + this.prefiexUrl + row.attSrc);
    },
    DownloadTheAttachment(item) {
      let parames = new URLSearchParams();
      parames.append("queId", item.queId);

      let ArrayList = [];
      this.$axios
        .post(this.serverUrl + "/ex/selectQueAttachment", parames)
        .then(resp => {
          //能进来此接口就一定有考试信息 直接循环获取
          resp.data.data.forEach(function(element, index) {
            ArrayList.push(element);
          });
          this.thatMaterialList = ArrayList;

          this.dialogTableVisible = true;
        })
        .catch(err => {});
    },
    laodExamSubject(testId, paperId) {
      const loading = this.$loading({
        lock: true,
        text: "试卷信息加载中,请稍后！",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      let subjectSumCount = 0;

      let parames = new URLSearchParams();
      parames.append("id", testId);
      parames.append("paperId", paperId);

      let ArrayList = [];
      this.$axios
        .post(this.serverUrl + "/ex/selectOneUserTestAll", parames)
        .then(resp => {
          //能进来此接口就一定有考试信息 直接循环获取
          this.examId = resp.data.data.examId;

          this.endTime = resp.data.data.endTime;

          this.beginTime = resp.data.data.beginTime;

          this.testSetTime = (resp.data.data.testSetTime / 1000 / 60).toFixed(
            1
          ); //考试规定用时

          this.testName =
            resp.data.data.workTypeName +
            resp.data.data.workTypeLevelAlias +
            "理论考试";

          this.workTypeName = resp.data.data.workTypeName;

          let endLongTime = new Date(resp.data.data.endTime).getTime();
          this.getSysTime();
          let _this = this;
          this.timer = setInterval(() => {
            let currentTimeStr = _this.showtime(endLongTime, _this.longTime);

            _this.longTime += 1000;

            if (currentTimeStr != "0:0:0") {
              _this.currentTime = currentTimeStr;
            } else {
              if (_this.flag) {
                _this.flag = false;

                //考试结束
                this.$message({
                  showClose: false,
                  duration: 3000,
                  message: "考试时间到，考试即将关闭！",
                  type: "warning",
                  offset: 300
                });

                setTimeout(function() {
                  _this.handInAnExaminationPaper(2); //保存学习进度
                }, 3000);
              }
            }
          }, 1000);

          resp.data.data.exercisesAndQueTypes.forEach(function(element, index) {
            //试题
            let exam = {
              queType: "", //试题类型
              typeName: "", //试题类型名称
              queScoreSum: 0, //试题类型分数总数
              SubjectCount: 0, //该类型试题数量
              examSubjectSonlist: []
            };

            let questionTypeList = element;

            exam.queType = questionTypeList.queType;
            exam.typeName = questionTypeList.typeName;

            let queScore = 0;
            let count = 0;
            questionTypeList.exercisesUserQuestionVos.forEach(function(
              element1,
              index1
            ) {
              if (
                element1.userAnswer != null &&
                element1.userAnswer != undefined &&
                element1.userAnswer != ""
              ) {
                element1.state = 2;
              } else {
                element1.state = 1;
              }

              count += 1;
              let enterParameterMultipleChoiceQuestion = element1;

              queScore += element1.queScore;

              subjectSumCount += 1;
              let userAnswerList = [];

              //如果是多选题  则创建数组 用户页面回显用
              if (element.queType == "02") {
                if (element1.userAnswer != null && element1.userAnswer != "") {
                  userAnswerList = element1.userAnswer.split(",");
                }
              }

              element1.userAnswerList = userAnswerList;

              if (element1.userAnswer != null && element1.userAnswer != "") {
                _this.currentProgress += 1;
              }
            });

            exam.examSubjectSonlist = questionTypeList.exercisesUserQuestionVos;
            exam.queScoreSum = queScore;
            exam.SubjectCount = count;

            ArrayList.push(exam);
          });
          this.examSubjectlist = ArrayList;

          this.subjectSumCount = subjectSumCount;

          loading.close();
        })
        .catch(err => {});
    }
  }
};
</script>

<style scoped>
.layui-layer-btn a {
  height: 28px;
  line-height: 28px;
  margin: 5px 5px 0;
  padding: 0 15px;
  border: 1px solid #dedede;
  background-color: #fff;
  color: #333;
  border-radius: 2px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
}

.layui-layer-btn .layui-layer-btn0 {
  border-color: #1e9fff;
  background-color: #1e9fff;
  color: #fff;
}

div /deep/ .el-dialog__body {
  padding: 0px 0px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

div /deep/ .el-dialog__header {
  display: none !important;
  padding: 20px 20px 10px;
}

div /deep/ .el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  z-index: 0 !;
  -webkit-transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.nav-status .menu-item-process .item-data {
  line-height: 17px;
  margin-bottom: 7px;
}

.nav-status .menu-item-process .item-label {
  margin-bottom: 11px;
}

.nav-status .menu-item-time .item-data,
.nav-status .menu-item-exam .item-data {
  font-size: 18px;
  line-height: 22px;
  color: #ff0000;
  font-weight: 400;
}

.nav-status .menu-item-time .item-label,
.nav-status .menu-item-exam .item-label {
  margin-bottom: 3px;
}

.nav-wrapper .nav250.nav-operation .menu-item {
  padding: 14px 0;
}

.form-btn-blue {
  color: #fff;
  background-color: #4b95ff;
  border-color: #4b95ff;
}

.nav-wrapper .nav250 {
  color: #27274a;
  line-height: 20px;
  padding: 0 10px;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);
  border-radius: 4px;
  margin-bottom: 10px;
  text-align: center;
  list-style: none;
}

.nav-wrapper {
  right: 23px;
  bottom: 20px;
  position: fixed;
  top: 120px;
  width: 7%;
}

.el-collapse {
  border: 1px solid #ebeef5;

  padding: 10px;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  height: 150px;
}

.layui-btn {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  padding: 0 18px;
  background-color: #009688;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
}

.layui-btn-xs {
  height: 22px;
  line-height: 22px;
  padding: 0 5px;
  font-size: 12px;
}

.form-checkbox label > input[type="radio"] + p::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 8px;
  height: 8px;
  left: 4px;
  top: 7px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #555555;
  -webkit-transform: scale(0, 0);
  -ms-transform: scale(0, 0);
  -o-transform: scale(0, 0);
  transform: scale(0, 0);
}

.form-checkbox label > input[type="radio"] + p::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 14px;
  height: 14px;
  left: 0;
  top: 3px;
  margin-left: -20px;
  border: 1px solid #cccccc;
  border-radius: 50%;
  background-color: #fff;
}

.form-checkbox > label {
  padding-left: 20px;
  position: relative;
}

.md-2018121002-xxw .item-listx label {
  display: flex;
  padding: 10px 15px;
  border: 1px solid transparent;
}

.md-2018121001-xxw {
  background: #049be2;
  height: 70px;
  line-height: 68px;
  position: fixed;
  top: 40px;
  left: 0;
  right: 0;
  z-index: 1;
}

.xxw107-icon {
  display: inline-block;
  padding: 8px;
  position: relative;
  top: 2px;
  left: -10px;
  display: none;
}

.md-2018121002-xxw .hd > .tit {
  display: block;
  align-items: baseline;
}

.md-2018121002-xxw .hd {
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;
}

.padding-100 {
  padding: 70px 100px 20px;
}

.md-2018121002-xxw .padding-100 {
  padding-bottom: 0;
  padding-top: 0;
}

.md-2018121002-xxw .test-paper-list {
  margin-bottom: 24px;
}

.other-1221-hd .s1 {
  font-size: 16px;
}

.other-1221-hd {
  padding: 0 22px;
  line-height: 42px;
  background: #d4f0fd;
  color: #014c85;
  font-size: 22px;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 36px;
}

.paper-body-xxw {
  background: #fff;
  margin-bottom: 60px;
  padding-bottom: 40px;
  position: relative;
  padding-top: 50px;
  margin-left: 265px;
}

.s2 {
  background: #1a8cfe;
}

.icon-label {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #656577;
}

.icon-box.s1 {
  background: #f1f3f8;
}

.modal-footer {
  padding: 10px 20px 10px 0px;
  background-color: #fff;
  border: unset;
  box-shadow: 0 -2px 10px 0 rgb(58 62 81 / 10%);
  text-align: right;
}

.iconBox {
  line-height: 32px;
  font-size: 14px;
  display: inline-block;
  width: 100%;
  height: 0%;
  color: #616a89;
  border-radius: 2px 2px 0 0;
}

.box {
  height: 32px;
  width: 32px;
  line-height: 18px;
  padding-bottom: 0;
  font-size: 0;
  display: inline-block;
  text-align: center;
  background: #f1f3f8;
  line-height: 12px;
  position: relative;
  margin: 0 3px 6px;
  border-radius: 2px 2px 0 0;
  overflow: hidden;
}

.s2 {
  background: #1a8cfe;
}

.icon-box {
  width: 10px;
  height: 10px;
  display: inline-block;
  margin: 0 3px 0px;
  padding-bottom: 0px;
}

.box-list .s1 {
  background: #f1f3f8;
}

.box-list {
  position: relative;
  left: -5px;
  font-size: 0;
  margin-right: -15px;
}

.card-content-title {
  font-size: 14px;
  color: #27274a;
  font-weight: 600;
  padding-bottom: 12px;
  padding-top: 20px;
}

.card-content {
  padding: 0 20px 0 20px;
  position: relative;
}

.card-content-list {
  font-size: 12px;
  color: #27274a;
  font-weight: 600;
}

.title_content {
  margin-left: 14px;
  font-weight: 600;
  color: #27274a;
}

.title_border {
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #1a8cfe;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.title {
  position: relative;
  text-align: left;
  margin-left: 20px;
  margin-bottom: 0;
  font-size: 18px;
  padding-bottom: 0px;
  color: #666666;
  letter-spacing: 0;
}

.modal-body {
  overflow-y: auto;
  height: 494px;
  padding-bottom: 36px;
}

.modal-header {
  padding: 10px;
  /* height: 20px; */
  border: none;
}

.ka {
  width: 15%;
  height: 550px;
  left: 37px;
  float: left;
  position: fixed;
  top: 120px;
  background-color: white;
  z-index: 999;
  box-shadow: 0 1px 4px 0 rgb(58 62 81 / 10%);
}

.parent {
  font-family: Microsoft YaHei, Helvetica Neue, Helvetica, STHeiTi, Arial,
    sans-serif;
  font-size: 16px;
  line-height: 1.4;
}

.md-2018121001-xxw .nav-xxw li a {
  display: block;
  color: inherit;
}

.md-2018121001-xxw .nav-xxw .active {
  color: #ffcc33;
  font-weight: bold;
}

.form-btn1 {
  display: inline-block;
  padding: 5px 0px 6px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  /* height: 32px; */
}

.form-btn {
  display: inline-block;
  padding: 5px 20px 6px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  /* height: 32px; */
}

.ks-btn {
  display: inline-block;
  line-height: 26px;
  background: #29b2f7;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.layui-bg-gray {
  background-color: #eee !important;
  color: #666 !important;
}

.layui-badge {
  height: 18px;
  line-height: 18px;
  position: relative;
  display: inline-block;
  padding: 0 6px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  border-radius: 2px;
}

.ks-typex {
  display: inline-block;
  line-height: 26px;
  background: #ec7064;
  color: #fff;
  padding: 0 16px;
  border-radius: 15px;
}

.layui-icon-search:before {
  content: "\e615";
}

.layui-icon {
  font-family: layui-icon !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.md-2018121102-xxw .form-group span {
  width: 48px;
  height: 50px;
  font-size: 24px;
  background: #bdc3c7;
  text-align: center;
  line-height: 46px;
  color: #fff;
  cursor: pointer;
}

.md-2018121102-xxw .form-group input {
  width: 750px;
  height: 100%;
  padding-left: 10px;
  background: #fdfdfd;
  border: none;
}

.md-2018121102-xxw .form-group {
  width: 800px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #bdc3c7;
  overflow: hidden;
}

.md-2018121102-xxw > .md-bd {
  padding: 30px 40px;
}

.color-28b2f7 {
  color: #28b2f7;
}

.bg-fff {
  background: #fff;
}

.padding-40px {
  padding: 0 40px;
}

.md-2018121102-xxw .md-hd {
  line-height: 50px;
  margin: 28px 0;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
}

.aaaaa {
  background: #f3f2f2;
  line-height: 24px;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
}

.md-2018121001-xxw .nav-xxw li {
  float: left;
  margin-right: 35px;
}

.md-2018121001-xxw .nav-xxw .active {
  color: #ffcc33;
  font-weight: bold;
}

.md-2018121001-xxw .nav-xxw {
  color: #ffffff;
  margin-left: 68px;
  font-size: 16px;
}

a {
  color: #333;
  text-decoration: none;
}

.container {
  clear: both;
  margin: 0 auto;
  text-align: left;
  width: 1200px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/exam/exam.vue